import { ClientPostTypeEnum } from '@DigitaleDoerfer/digitale-doerfer-api';
import type { FC } from 'react';
import { StyleSheet } from 'react-native';

import { usePostCard } from '@/features/posts/components/feed/PostCardContext';
import { PostTypeButton } from '@/features/posts/components/PostTypeButton';
import { Row } from '@/shared/components/layout/Row';

const styles = StyleSheet.create({
  container: {
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    padding: 8
  }
});

export const PostCardCompactBadge: FC = () => {
  const { postType } = usePostCard();

  if (
    postType !== ClientPostTypeEnum.Offer &&
    postType !== ClientPostTypeEnum.Seeking
  ) {
    return <></>;
  }

  return (
    <Row style={styles.container}>
      <PostTypeButton postType={postType} asChip />
    </Row>
  );
};
PostCardCompactBadge.displayName = 'PostCardCompactBadge';
